
import React from 'react';
import { useForceUpdate } from 'js/sign-components/common/hooks';

const componentMap = new WeakMap<React.ComponentType<any> | Function, Array<() => void>>();
export function useIsLastMountedInstanceOf(Component: React.ComponentType<any> | Function) {
  const forceUpdate = useForceUpdate();
  if (!componentMap.has(Component)) {
    componentMap.set(Component, []);
  }
  const stack = componentMap.get(Component)!;

  React.useEffect(() => {
    function notifyOtherInstances() {
      stack.forEach(
        (otherInstance) => otherInstance(),
      );
    }

    stack.unshift(forceUpdate);
    notifyOtherInstances();
    return () => {
      const idx = stack.indexOf(forceUpdate);
      stack.splice(idx, 1);
      notifyOtherInstances();
    };
  }, [forceUpdate, stack]);

  return (
    // This must be the first one mounted because useEffect hasn't run yet
    stack.length === 0
    || stack[0] === forceUpdate
  );
}
